import Constants from '../constants'

export default {
   NETWORK_URL: Constants.BASE_URL + '/network'
}

export const Actions = {
   new:    'network:new',
   update: 'network:update',
   list:   'network:list',
   change: 'network:change'
}



// WEBPACK FOOTER //
// lib/api/network/Constants.js